export const PERMISSION_BASED_REDIRECTION_ON_NO_ACCESS_TOKEN = {
	permissionBasedRedirectionOnNoAccess: true,
};
